// ** Icons Import
import {
  Home,
  Circle,
  User,
  Users,
  Box,
  Bell,
  Flag,
  DollarSign,
  Settings,
  TrendingUp
} from 'react-feather';

// ** Icons Import

export default [
  {
    id: 'DASHBOARD',
    title: 'Dashboard',
    icon: <Home />,
    // badge: 'light-warning',
    // badgeText: '0',
    navLink: '/dashboard'
  },
  {
    id: 'USERS',
    title: 'User',
    icon: <User />,
    navLink: '/apps/user/list'
  },
  {
    id: 'ADMINS',
    title: 'Administradores',
    icon: <Users />,
    navLink: '/administrators'
  },
  {
    id: 'ROADS',
    title: 'Caminos',
    icon: <Box />,
    children: [
      {
        id: 'activities',
        title: 'Actividades',
        icon: <Circle />,
        navLink: '/roads/activities/list'
      },
      {
        id: 'episodes',
        title: 'Episodios',
        icon: <Circle />,
        navLink: '/roads/episodes/list'
      },
      {
        id: 'roads',
        title: 'Caminos',
        icon: <Circle />,
        navLink: '/roads/list'
      }
    ]
  },
  {
    id: 'RANKING',
    title: 'Ranking',
    icon: <TrendingUp />,
    children: [
      {
        id: 'roads',
        title: 'Caminos',
        icon: <Circle />,
        navLink: '/ranking/roads'
      },
      {
        id: 'emotions',
        title: 'Emociones',
        icon: <Circle />,
        navLink: '/ranking/emotions'
      }
    ]
  },
  {
    id: 'NOTIFICATION',
    title: 'Notificaciones',
    icon: <Bell />,
    children: [
      {
        id: 'deliberate',
        title: 'Deliberados',
        icon: <Circle />,
        navLink: '/notifications/deliberate'
      },
      {
        id: 'scheduled',
        title: 'Programadas',
        icon: <Circle />,
        navLink: '/notifications/scheduled'
      }
    ]
  },
  {
    id: 'ACHIEVEMENTS',
    title: 'Mis Logros',
    icon: <Flag />,
    navLink: '/my-achievements'
  },
  {
    id: 'INCOME',
    title: 'Ingresos',
    icon: <DollarSign />,
    navLink: '/income'
  },
  {
    id: 'CONFIG',
    title: 'Configuracion',
    icon: <Settings />,
    children: [
      {
        id: 'general',
        title: 'General',
        icon: <Circle />,
        navLink: '/settings/general'
      },
      {
        id: 'themes',
        title: 'Temas',
        icon: <Circle />,
        navLink: '/settings/themes'
      },
      {
        id: 'phrase-design',
        title: 'Diseño Frases',
        icon: <Circle />,
        navLink: '/settings/phrase-design'
      }
    ]
  }
];
